<template>
  <div id="header-guide" class="container column is-paddingless-top is-paddingless-bottom">
    <div class="header columns">
      <div class="column columns is-3 is-paddingless">
        <div class="column titre">
          <p class="is-size-5 is-marginless"><strong>Nom du produit (à venir)</strong></p>
        </div>
      </div>
      <div class="columns is-mobile column is-padding-left-small is-paddingless-top is-paddingless-bottom">
        <div class="tabs">
          <ul>
            <li class="is-active"><a href="#">Guide d'utilisation</a></li>
            <li v-if="this.profil != null"><a href="#">Tutoriel vidéo</a></li>
            <li v-if="this.profil != null"><a href="#">Support technique</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomHeader',
  computed: {
    ...mapState(['link', 'profil', 'tokentab'])
  }
}
</script>
